<div
  id="carouselExampleCaptions"
  class="carousel slide"
  [dir]="language == 'ar' ? 'rtl' : 'ltr'"
>
  <div class="carousel-inner">
    <div
      *ngFor="let item of services; let i = index"
      class="carousel-item"
      [class.active]="i === 0"
    >
      <img
        [src]="item?.imageIconPath"
        class="d-block w-100"
        [alt]="item?.imageAlt"
        loading="lazy"
      />
      <div class="overlay">
        <div class="container">
          <div class="overlay-content">
            <h1>{{ item.titleTr }}</h1>
            <p class="overlay-content-text">{{ item.summary }}</p>
            <app-app-button
              [buttonText]="item.buttonText"
              [link]="getLinkUrl(item)"
              *ngIf="isDetails"
            ></app-app-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <button
    class="carousel-control-prev"
    type="button"
    data-bs-target="#carouselExampleCaptions"
    data-bs-slide="prev"
  >
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button
    class="carousel-control-next"
    type="button"
    data-bs-target="#carouselExampleCaptions"
    data-bs-slide="next"
  >
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>
